import { z } from 'zod/v4';

import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';

export const hazmatTypeOptions = [
  'None',
  'General',
  'Explosives',
  'Inhalants',
  'Radioactive',
  'Caustic',
  'Flammable',
  'HarmfulToWater',
] as const;

export const hazmatTypeSchema = createEnumSchemaPreprocessor(
  z.enum(hazmatTypeOptions),
  hazmatTypeOptions
);

export type HazmatType = z.infer<typeof hazmatTypeSchema>;
